// extracted by mini-css-extract-plugin
module.exports = {"root":"EmployeeBox_root__AVIdW","_image-wrapper":"EmployeeBox__image-wrapper__FDeW9","_info-wrapper":"EmployeeBox__info-wrapper__LX2GC"};